import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText
} from 'reactstrap';
import { inject, observer } from "mobx-react";
import ReactJson from 'react-json-view';

@inject("userStore") @observer
class UserProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userData: {},
    };
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    const userId = this.props.match.params.id;
    console.log(userId);
    const res = await this.props.userStore.getUserDetailById(userId);
    if (!!res.data) this.setState({ userData: res.data || {} })
  }

  render() {
    const { match } = this.props;
    const userId = match.params.id;
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" md="12">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i>Thông tin của user: <strong>{userId}</strong> (dữ liệu thô)
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs="12" md="12" >
                    <ReactJson 
                      src={this.state.userData}
                      name={userId}
                      displayDataTypes={false}
                      theme={"ocean"}
                    />
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                {/* <Button type="submit" size="sm" color="primary" onClick={this.editProfile}><i className="fa fa-dot-circle-o"></i> Save</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Cancel</Button> */}
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  renderOld() {

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> User Info
              </CardHeader>
              <CardBody>
                <Form action="" method="post" onSubmit={e => e.preventDefault()}>
                  <FormGroup>
                    <Label htmlFor="nf-email">Username:</Label>
                    <Input type="text" id="nf-email" name="nf-email" />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">Email:</Label>
                    <Input type="text" id="nf-email" name="nf-email" />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">First name:</Label>
                    <Input type="text" id="nf-email" name="nf-email" />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">Last name:</Label>
                    <Input type="text" id="nf-email" name="nf-email" />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">Job title:</Label>
                    <Input type="text" id="nf-email" name="nf-email" />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">About me:</Label>
                    <textarea className="form-group form-control" rows={4} />
                  </FormGroup>
                  
                  <FormGroup row>
                    <Col md="3">
                      <Label htmlFor="multiple-select">Account Type:</Label>
                    </Col>
                    <Col md="9">
                      <Input type="select" name="multiple-select" id="multiple-select" >
                        <option value="1">Project Owner</option>
                        <option value="2">Contractor</option>
                        <option value="3">Supplier</option>
                      </Input>
                    </Col>
                  </FormGroup>
                </Form>
              </CardBody>
              <CardFooter>
                <Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Save</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Cancel</Button>
              </CardFooter>
            </Card>
          </Col>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> Profile Picture
              </CardHeader>
              <CardBody>
                <div style={{
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex"
                }}>
                  <img src="http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg" 
                    style={{width: 300, height: 300, borderRadius: "100%", marginBottom: 20 }} />
                  <Button color="danger"><i className="fa fa-camera"></i> Upload new image</Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>
    );
  }
}

export default UserProfile;


// WEBPACK FOOTER //
// ./src/views/Users/UserProfile.js